export default __webpack_public_path__ + "static/media/E-commerce-gif4.22a68b84.gif";